import { useContext } from 'react';
import { ThemeContext } from '../context/theme/ThemeProvider';
import { commonBase, colorSceneLight, colorSceneDark, } from '@kid/Kwai_LA-color/color/output/common/index';
export function useTheme() {
    return useContext(ThemeContext);
}
export function useThemeValue(value, modeType) {
    const { mode } = useContext(ThemeContext);
    const currentMode = modeType || mode;
    return value[currentMode];
}
export function useKidColor(kidcolor, modeType) {
    const { mode } = useTheme();
    const currentMode = modeType || mode;
    if (kidcolor.indexOf('cs_') === 0) {
        return currentMode === 'dark'
            ? colorSceneDark[kidcolor]
            : colorSceneLight[kidcolor];
    }
    return commonBase[kidcolor];
}
